module.exports = __webpack_public_path__ + "img/galeria-especie-prioritaria-8.18049fc2.jpg";